import { setIsActiveSpinner } from "../../Redux/GeneralSlice";
import { setFeeTiers } from "../../Redux/TiersSlice";
import TiersService from "../../Services/http/TiersService";

export const getFeeTiers = async (dispatch) => {
  dispatch(setIsActiveSpinner(true));
  const response = await TiersService.getFeeTiers();
  dispatch(setIsActiveSpinner(false));
  if (response && response["message"] === "success") {
    dispatch(setFeeTiers(response));
  }
};

export const updateFeeTiersInDB = async (dispatch, feeTier) => {
  dispatch(setIsActiveSpinner(true));
  const response = await TiersService.updateFeeTiersRow(feeTier);
  dispatch(setIsActiveSpinner(false));
  if (!response || response["message"] !== "success") {
    alert(response["message"]);
  }
  getFeeTiers(dispatch);
};
